var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSteeringWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A214842-D8BA-4365-A26B-2992C65CC42B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C14.9705627,1 19,5.02943725 19,10 C19,14.9705627 14.9705627,19 10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 Z M3.82876789,13.3068167 C4.77658808,15.0719494 6.45958632,16.3834965 8.46819244,16.8318878 C7.9612488,15.1687223 6.61820105,13.8755171 4.9172026,13.4450696 L3.82876789,13.3068167 Z M16.1712321,13.3068167 L15.0827937,13.4457663 C13.3805493,13.8759502 12.0367789,15.1706416 11.5302427,16.8305318 C13.5398566,16.3839307 15.2232551,15.0722416 16.1712321,13.3068167 Z M10,10 C9.44771525,10 9,10.4477153 9,11 C9,11.5522847 9.44771525,12 10,12 C10.5522847,12 11,11.5522847 11,11 C11,10.4477153 10.5522847,10 10,10 Z M10,3 C6.6060012,3 3.77616495,5.41546704 3.13577221,8.62112015 L4.17333333,8.4816 L4.93777778,8.3856 L6.01777778,8.2616 L7.01777778,8.1616 L7.64,8.10826667 L8.36777778,8.0566 L9.04,8.0216 L9.53777778,8.0056 L9.77333333,8.0016 L10.2266667,8.0016 L10.8322222,8.0166 L11.4933333,8.04826667 L12.21,8.0966 L12.9822222,8.1616 L13.64,8.2256 L14.3333333,8.30026667 L15.0622222,8.3856 L15.8266667,8.4816 L16.8642278,8.62112015 C16.2238351,5.41546704 13.3939988,3 10,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\u0101kums",
    transform: "translate(-15.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSteeringWheel);
export default __webpack_public_path__ + "static/media/ic-steering-wheel.677ce233d741dfb34c15228de384651b.svg";
export { ForwardRef as ReactComponent };